<!-- Popup -->
<div class="popup-overlay" *ngIf="showPopup" (click)="closePopup()">
    <div class="popup-container" (click)="$event.stopPropagation()">
        <button class="popup-close" (click)="closePopup()" aria-label="Cerrar">&times;</button>
        <img src="assets/images/POP_UP_DIUTIN.webp" alt="Promoción Diutin" class="popup-image">
    </div>
</div>

<div class="content-banner">
    <!-- banner -->
    <div class="swiper-container gallery-top">
        <div class="swiper-wrapper">
            <div class="swiper-slide px-0 px-md-5 px-xxl-4" *ngFor="let g of gallery; let i = index" [id]="i == 0 ? 'first':''" style="background-image: url({{g.background}});">
                <div class="content-section d-flex flex-column flex-md-row al-center section-banner h-100" [ngClass]="i == 0 ? 'sp-between' : 'sp-center'">
                    <ng-container *ngIf="g.title">
                        <div class="content-left text-center text-md-start">
                            <div>
                                <span class="fs-title fw-black text-blue">{{g.title}}</span>
                            </div>
                            <br *ngIf="i == 0">
                            <div class="d-none d-md-inline"><br></div>
                            <div class="content-description">
                                <span class="fs-2 fw-regular text-blue">{{g.description}}</span>
                            </div>
                            <ng-container *ngIf="i != 2">
                                <br>
                            </ng-container>
                            <div class="d-none d-lg-inline">
                                <ng-container *ngIf="i != 2">
                                    <br><br><br>
                                </ng-container>
                            </div>
                            <ng-container *ngIf="g.icons.length > 0">
                                <div class="d-flex al-center content-icons justify-content-center justify-content-md-start my-3 my-lg-0">
                                    <img [src]="icon" width="100" *ngFor="let icon of g.icons" alt="">
                                </div>
                            </ng-container>
                            <div class="d-none d-lg-inline">
                                <br><br>
                            </div>
                            <ng-container *ngIf="g.action">
                                <div class="button-action bg-blue al-center d-flex sp-center fw-medium pointer" (click)="goTo(g.redirecto)">
                                    <span class="text-white fs-4">{{g.action}}</span>
                                </div>
                            </ng-container>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="i == 0">
                        <div class="content-right text-center text-md-start mb-3 mb-md-0">
                            <img src="assets/images/background-responsive.webp" class="first-banner d-block d-md-none" alt="">
                        </div>
                    </ng-container>
                    <ng-container *ngIf="g.image">
                        <div [ngClass]=" i == 3 ? ['d-flex','flex-column','h-100','sp-center']:''">
                            <div class="content-right text-center" [ngClass]=" i == 1 || i == 2 ? ['img-responsive','text-md-start']: i == 3 ? 'p-3 p-sm-0' : 'text-md-start'">
                                <img [src]="g.image" [ngClass]="i == 1 || i == 2 ? 'image-banner w-100' : 'width-custom'" alt="">
                                <ng-container *ngIf="i == 3">
                                    <div class="button-action bg-blue al-center d-flex sp-center fw-medium mt-3 pointer" (click)="goTo(g.redirecto)">
                                        <span class="text-white fs-4">{{g.action}}</span>
                                    </div>
                                </ng-container>
                            </div>
                            
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
        <div class="swiper-pagination pb-2"></div>
    </div>
    <div class="px-4 px-md-5 px-xxl-4">
        <!-- products -->
        <div class="content-section content-products py-5">
            <div>
                <div class="text-center">
                    <span class="fs-0 text-blue fw-extrabold">{{content.titleProductLanding}}</span>
                </div>
                <div class="d-flex sp-center mt-3">
                    <div class="line"></div>
                </div>
                <br><br><div class="d-none d-md-inline"><br><br><br></div>
                <div *ngFor="let product of content.productsLanding" class="px-0 px-lg-5">
                    <app-product-banner [detail]="product"></app-product-banner>
                </div>
            </div>
        </div>
        <!-- social -->
        <div class="content-section py-5">
            <div>
                <div class="text-center">
                    <span class="fs-0 text-blue fw-extrabold">{{content.titleSocial}}</span>
                </div>
                <div class="d-flex sp-center mt-3">
                    <div class="line"></div>
                </div>
                <br><br><div class="d-none d-md-inline"><br><br><br></div>
                <div class="row sp-center">
                    <div *ngFor="let social of content.socialLanding" class="col-md-6 col-lg-4">
                        <app-social [social]="social"></app-social>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>